import React from "react";
import ClipboardTickIcon from "../../../assets/icons/front-pages/clipboard-tick.svg";
import RefreshCircleIcon from "../../../assets/icons/front-pages/refresh-circle.svg";
import NotificationStatusIcon from "../../../assets/icons/front-pages/notification-status.svg";
import TrendUpIcon from "../../../assets/icons/front-pages/trend-up.svg";

import CardsIcon from "../../../assets/icons/front-pages/cards.svg";
import ReceiptIcon from "../../../assets/icons/front-pages/receipt.svg";
import DownloadIcon from "../../../assets/icons/front-pages/download.svg";
import ClockIcon from "../../../assets/icons/front-pages/clock.svg";

import { FrontPagesFeatures } from "../commons";

const InvoiceLinksFeatures = () => {
  return (
    <FrontPagesFeatures
      headerTextSeries={[
        ["Why", "you", "should", "collect"],
        ["payments", "with", "invoice", "links"],
      ]}
      cta={{
        title: (
          <>
            Want to start collecting <br /> payments seamlessly?
          </>
        ),
        text: "Start using payments",
      }}
      features={features}
      image={{
        src: "https://res.cloudinary.com/catlog/image/upload/v1670997020/front-pages/woman-sitting-with-phone.png",
        alt: "Woman sitting with phone",
      }}
    />
  );
};

const features = [
  {
    icon: ClockIcon,
    description: "Creating an invoice link is easy, all it takes is 2 minutes",
  },
  {
    icon: CardsIcon,
    description: "Your customers can pay you via card, transfers, bank & even split payments",
  },
  {
    icon: ReceiptIcon,
    description: "Payments are confirmed instantly, your customers also get a receipt",
  },
  {
    icon: DownloadIcon,
    description: "You can always download a PDF copy of your invoices, when you need them",
  },
];

export default InvoiceLinksFeatures;
